<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";

export default {
  page: {
    title: "Mark SMS",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Mark SMS",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Bulk SMS",
          href: "/bulk-sms",
        },
        {
          text: "Marks SMS",
          active: true,
        },
      ],
      data: {
        class: "",
        month: "",
        course: "",
        testResults: "",
      },
      months: [
        { value: "01", month: "January" },
        { value: "02", month: "February" },
        { value: "03", month: "March" },
        { value: "04", month: "April" },
        { value: "05", month: "May" },
        { value: "06", month: "June" },
        { value: "07", month: "July" },
        { value: "08", month: "August" },
        { value: "09", month: "September" },
        { value: "10", month: "October" },
        { value: "11", month: "November" },
        { value: "12", month: "December" },
      ],
      pageError: {
        classError: false,
      },
    };
  },

  computed: {
    ...mapGetters("classes", [
      "AllClasses",
      "AllStreams",
      "AllCourses",
      "CustomClasses",
    ]),
    ...mapGetters("coursework", ["AllSets"]),
    ...mapGetters("bulksms", [
      "getMarksResponse",
      "getMarksSMS",
      "getSmsCalc",
      "getsmsBalance",
      "SaveStatus",
    ]),
    ...mapGetters("marks", ["getTestResult"]),
    ...mapGetters("auth", ["getCurrentUser"]),
  },
  mounted() {},
  methods: {
    ...mapActions({
      FetchClasses: "classes/fetchClasses",
      FetchSets: "coursework/fetchSets",
      SubmitMarksSMS: "bulksms/submitMarksSMS",
      ExamSmsCalc: "bulksms/examSmsCalc",
      FetchSmsBalance: "bulksms/fetchSmsBalance",
      FetchCustomClasses: "classes/fetchCustomClasses",
      FetchResults: "marks/fetchResults",
      FetchCourses: "classes/fetchCourses",
    }),

    sendMarksSms() {
      this.data.class != "" &&
      this.data.month != "" &&
      this.data.course != "" &&
      this.data.testResults != ""
        ? this.SubmitMarksSMS(this.data)
        : null;
    },

    calculateSms() {
      this.data.classes != "" &&
      this.data.month != "" &&
      this.data.course != "" &&
      this.data.testResults != ""
        ? this.ExamSmsCalc(this.data)
        : null;
    },

    fetchClasses() {
      const selectedCourse = { course: this.data.course };
      this.FetchCustomClasses(selectedCourse);
    },

    fetchTestResults() {
      this.FetchResults(this.data);
    },

    resetError() {
      this.data.classes.length
        ? (this.pageError.classError = false)
        : (this.pageError.classError = true);
    },
  },
  created() {
    this.FetchSets();
    this.FetchSmsBalance();
    this.FetchClasses();
    this.FetchCourses();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row d-flex"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('send_marks_sms')
        )
      "
    >
      <div class="col-md-11 mx-auto">
        <div class="card row">
          <form @submit.prevent="sendMarksSms">
            <div class="card-body col-md-12 mx-auto row">
              <div class="row col-md-6">
                <div class="form-group col-md-12 mb-3">
                  <label>Courses <small class="text-danger">*</small></label>
                  <div class="input-group mb-3">
                    <select
                      required
                      class="form-control"
                      v-model="data.course"
                      @change="calculateSms(), fetchClasses()"
                    >
                      <option value="" disabled selected>Select Course</option>
                      <option
                        v-for="(course, index) in AllCourses"
                        :value="course.id"
                        :key="index"
                        >{{ course.name }}</option
                      >
                    </select>
                  </div>
                  <label>Level <small class="text-danger">*</small></label>
                  <div class="input-group">
                    <select
                      required
                      class="form-control"
                      v-model="data.class"
                      @change="calculateSms()"
                    >
                      <option value="" disabled selected>Select Level</option>
                      <option
                        v-for="(level, index) in CustomClasses"
                        :value="level.id"
                        :key="index"
                        >{{ level.name }}</option
                      >
                    </select>
                  </div>
                </div>

                <div class="form-group col-md-12 mb-3">
                  <label for=""
                    >Month <small class="text-danger">*</small></label
                  >
                  <select
                    class="form-control"
                    v-model="data.month"
                    @change="calculateSms(), fetchTestResults()"
                    name=""
                    id=""
                  >
                    <option value="" selected disabled>Select Month</option>
                    <option
                      v-for="(month, index) in months"
                      :value="month.value"
                      :key="index"
                    >
                      {{ month.month }}
                    </option>
                  </select>
                </div>

                <div class="form-group col-md-12 mb-3">
                  <label for=""
                    >Test Results <small class="text-danger">*</small></label
                  >
                  <select
                    class="form-control"
                    v-model="data.testResults"
                    name=""
                    id=""
                    @change="calculateSms()"
                  >
                    <option value="" selected disabled>Select Results</option>
                    <option
                      v-for="(result, index) in getTestResult"
                      :value="result.date"
                      :key="index"
                    >
                      On {{ result.date }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-12 mt-3">
                  <div
                    class="alert alert-danger"
                    role="alert"
                    v-if="
                      getsmsBalance.deposit -
                        getsmsBalance.used -
                        getSmsCalc.total_sms <
                        0
                    "
                  >
                    <h5 class="card-title text-danger">
                      <i class="fa fa-exclamation" aria-hidden="true"></i>
                      Caution
                      <i class="fa fa-exclamation" aria-hidden="true"></i>
                    </h5>
                    <span>
                      You have Less SMS Balance, Please subscribe for more SMS
                      before you continue.
                      <br />
                      <br />
                      <router-link
                        to="/bulk-sms/settings"
                        role="button"
                        class="btn btn-sm btn-primary"
                      >
                        <i class="fa fa-circle-check"></i>
                        Click to Subscribe
                      </router-link>
                    </span>
                  </div>
                </div>
              </div>
              <div class="row col-md-6">
                <div class="col-lg-12 col-md-12">
                  <div class="text-primary mb-2">
                    <strong>Total Students/Messages</strong>
                  </div>
                  <div class="text-muted">
                    <p class="mb-1">
                      <i class="mdi mdi-circle-medium align-middle me-1"></i>
                      <strong>Total Students </strong
                      ><span class="card-title">{{
                        getSmsCalc.total_std
                      }}</span>
                      |
                      <strong>Total SMS/Messages</strong>
                      <span class="card-title">
                        {{ getSmsCalc.total_sms }}
                      </span>
                    </p>
                  </div>
                  <div class="text-muted">
                    <p class="mb-1 text-success">
                      <i class="mdi mdi-circle-medium align-middle me-1"></i>
                      <strong>Total SMS/Messages Balance</strong> |
                      <span class="card-title">{{
                        getsmsBalance.deposit - getsmsBalance.used
                      }}</span>
                    </p>
                  </div>
                </div>
                <div class="col-md-12 mt-3">
                  <button
                    v-if="SaveStatus"
                    type="button"
                    disabled
                    class="btn btn-primary btn-sm float-end"
                  >
                    <b-spinner
                      variant="light"
                      small
                      label="Spinning"
                    ></b-spinner>
                    Sending Wait...
                  </button>
                  <button
                    v-else-if="
                      pageError.classError ||
                        getsmsBalance.deposit -
                          getsmsBalance.used -
                          getSmsCalc.total_sms <
                          0
                    "
                    type="button"
                    disabled
                    class="btn btn-primary btn-sm float-end"
                  >
                    Send Message(s)
                    <i class="fa fa-paper-plane" aria-hidden="true"></i>
                  </button>
                  <button
                    v-else
                    type="submit"
                    class="btn btn-outline-primary btn-sm float-end"
                  >
                    Send Message(s)
                    <i class="fa fa-paper-plane" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
